(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acc-story-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('.acc-story-video__play-button');
    if (!button) return;

    const shell = button.closest('.acc-story-video__player-shell');
    if (!shell) return;

    const video = shell.querySelector('video');
    if (!video) return;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => shell.classList.remove('is-playing'));
    }
  });

  document.addEventListener(
    'playing',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      const shell = video.closest('.acc-story-video__player-shell');
      if (shell) shell.classList.add('is-playing');
    },
    true
  );

  document.addEventListener(
    'pause',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      const shell = video.closest('.acc-story-video__player-shell');
      if (shell) shell.classList.remove('is-playing');
    },
    true
  );

  document.addEventListener(
    'ended',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      const shell = video.closest('.acc-story-video__player-shell');
      if (shell) shell.classList.remove('is-playing');
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
